import React from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import { find, get } from 'lodash';
import { useGetCustomerHandler } from '../dataHandlers/getCustomerHandler';
import useOrganizationFilters from '../../organizations/components/OrganizationFilterHelper';

export const CustomerSelectField = ({ label = 'Customer', name, control, errors, readOnly = false }) => {
  const { currentQuery, handleSearchChange } = useOrganizationFilters({
    defaultQuery: {},
    searchOnChange: true,
  });

  const { customers, isLoading } = useGetCustomerHandler({ searchQuery: currentQuery });
  const errorMessage = get(errors, `${name}.message`, '');

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedOption = find(customers || [], { stripe_customer_id: field?.value }) || null;

        return (
          <Box display="flex" alignItems="flex-start" gap={2}>
            <Autocomplete
              loading={isLoading}
              id={name}
              fullWidth
              readOnly={readOnly}
              options={customers || []}
              getOptionLabel={(option) => `${option.name} | ${option.email} | ${option.stripe_customer_id}`}
              getOptionKey={(option) => option.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={label}
                  error={!!errorMessage}
                  helperText={errorMessage}
                  slotProps={{
                    input: {
                      ...params.InputProps,
                      endAdornment: (
                        <React.Fragment>
                          {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                          {params.InputProps.endAdornment}
                        </React.Fragment>
                      ),
                    },
                  }}
                />
              )}
              isOptionEqualToValue={(option, value) => option.stripe_customer_id === value?.stripe_customer_id}
              onChange={(_, value) => field.onChange(value?.stripe_customer_id || '')}
              value={selectedOption}
              onInputChange={(_, value, reason) => {
                if (reason === 'input') {
                  handleSearchChange(value);
                }
              }}
              filterOptions={(x) => x}
            />
          </Box>
        );
      }}
    />
  );
};
